import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CartStep2InsuranceRepository } from '@/core/domain/cart-step2/repositories/cart-step2-insurance.repository';
import { sendCartStep2InsuranceUseCase } from '@/core/domain/cart-step2/usecases/sendCartStep2Insurance.usecase';
import { CartStep2InsuranceImplRepository } from './cart-step2-insurance-impl.repository';

const sendCartStep2InsuranceUseCaseFactory = (
    cartStep2InsuranceRepository: CartStep2InsuranceRepository,
) => new sendCartStep2InsuranceUseCase(cartStep2InsuranceRepository);

@NgModule({
    imports: [CommonModule],
    providers: [
        {
            provide: sendCartStep2InsuranceUseCase,
            useFactory: sendCartStep2InsuranceUseCaseFactory,
            deps: [CartStep2InsuranceRepository],
        },
        {
            provide: CartStep2InsuranceRepository,
            useClass: CartStep2InsuranceImplRepository,
        },
    ],
})
export class CartStep2InsuranceDataModule {}
